// /opt/isp_erp/frontend/src/pages/ftth/Topology.jsx
import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

const Topology = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>🌐 Topología de Red FTTH</Typography>
      <Paper sx={{ p: 3, textAlign: 'center', minHeight: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box>
          <Typography variant="body1" color="text.secondary">Próximamente: Visualización de la topología de red</Typography>
          <Typography variant="caption" color="text.secondary">Integración con OLT y NAPs</Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default Topology;
